import React from 'react';
import { Link } from 'react-router-dom';
import { Send } from 'lucide-react';

const ServiceCTA = ({ 
  title = "お気軽にご相談ください",
  description = "「自分のお店にはどのサービスが合うのか分からない」という方も、お気軽にご相談ください。",
  buttonText = "無料相談はこちら"
}) => {
  return (
    <section className="py-16" style={{ backgroundColor: '#F7C9D3' }}>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
          {title}
        </h2>
        <p className="text-lg mb-8 max-w-2xl mx-auto" style={{ color: '#2C2C2C' }}>
          {description}
        </p>
        <Link 
          to="/contact" 
          className="btn-primary inline-flex items-center px-8 py-4 rounded-full text-lg font-semibold"
        >
          <Send className="w-5 h-5 mr-2" />
          {buttonText}
        </Link>
        <p className="text-sm mt-4" style={{ color: '#2C2C2C', opacity: 0.8 }}>
          ※ メールでのご相談が中心です。必要な場合のみオンライン対応いたします。
        </p>
      </div>
    </section>
  );
};

export default ServiceCTA;